// Actions for the model parameters reducer
import * as types from "./types"
import store from '../store';
import * as con from "./../../Constants"




// Set Application Parameter 
export const setApplicationData = (dataId, data) =>
{    

    let payload = {[con.ID]: dataId, [con.VALUE] : data}

    store.dispatch({
        type : types.SET_APPLICATION_DATA,
        payload : payload
    })
}


